class CheckoutOverview {
  constructor(checkoutSteps) {
    this.rows = [];
    this.checkoutSteps = checkoutSteps;
    this.initRows();

    jQuery(document).on('checkoutStepChanged', (event, currentStepId) => {
      this.updateData();
      this.updateVisibility(currentStepId);
    });

    if (this.checkoutSteps && this.checkoutSteps.isInitialized) {
      const currentStepId = this.checkoutSteps.activeStep ? this.checkoutSteps.activeStep.id : null;
      this.updateVisibility(currentStepId);
    }
  }

  initRows() {
    const rowElements = jQuery('.mad-checkout-overview > .mad-checkout-overview__row-container');
    rowElements.each((i, rowElement) => {
      const row = new CheckoutOverviewRow(rowElement, this.checkoutSteps);
      this.rows.push(row);
    });
  }

  updateData() {
    var checkoutData = this.getCheckoutData();
    // console.log('updateData', checkoutData)

    // Select all items within rows that have a data-checkout-data-id attribute.
    var items = jQuery('.mad-checkout-overview__row-content--item[data-checkout-data-id]');

    items.each((_, element) => {
      var item = jQuery(element);
      var normalDataId = item.data('checkout-data-id');
      var altDataId = item.data('checkout-data-alt-id') || null;
      var altCondition = item.data('checkout-data-alt-condition');
      var isAltConditionMet = altCondition ? checkoutData[altCondition] : false;
      var dataIdToUse;

      // Determine which data ID to use based on the presence of alternative attributes and the condition
      if (altDataId && isAltConditionMet) {
        dataIdToUse = altDataId;
      } else {
        dataIdToUse = normalDataId;
      }

      var checkoutDataValue = checkoutData[dataIdToUse];

      // Get data label if 'use-label' attribute is set
      if (null != item.attr('use-label')) {
        checkoutDataValue = this.getDataLabel(item, dataIdToUse, checkoutDataValue);
      }

      // Update the item's content if the corresponding data exists
      if (checkoutDataValue !== undefined) {
        item.html(checkoutDataValue);
      }
    });
  }

  getDataLabel(item, dataIdToUse, checkoutDataValue) {
    var inputElement = jQuery(`[name="${dataIdToUse}"]`);

    if (inputElement.is(':radio')) {
      var checkedRadio = inputElement.filter(':checked');
      if (checkedRadio.length > 0) {
        inputElement = checkedRadio; // Update inputElement to the checked radio button
      } else {
        return checkoutDataValue; // no checked radio button, return the existing value
      }
    }

    if (inputElement.length > 0) {
      if (inputElement.attr('data-overview-label') != null) {
        checkoutDataValue = inputElement.attr('data-overview-label');
      } else if (inputElement.is('select')) {
        var selectedOption = inputElement.find(`option[value="${checkoutDataValue}"]`);
        checkoutDataValue = selectedOption.text();
      } else {
        var labelElement = jQuery(`label[for="${inputElement.attr('id')}"]`);
        if (labelElement.length > 0) {
          checkoutDataValue = labelElement.html();
        }
      }
    }

    return checkoutDataValue;
  }


  updateVisibility(currentStepId) {
    this.rows.forEach(row => {
      // Check if the row is marked as disabled
      if (!row.element.attr('disabled')) {
        row.toggleVisibility(currentStepId, this.checkoutSteps);
      } else {
        // Immediately hide rows marked as disabled
        row.element.hide();
        row.isVisible = false;
      }
    });

    if (this.rows.some((row) => row.isVisible)) {
      jQuery('.mad-checkout-overview__container').show();
    } else {
      jQuery('.mad-checkout-overview__container').hide();
    }
  }


  getCheckoutData() {
    var formDataArray = jQuery('form.mad-checkout-form').serializeArray(); // Serialize form data
    var formDataObj = {};

    jQuery.each(formDataArray, function (index, field) {
      formDataObj[field.name] = field.value;
    });

    if (jQuery('input[name="ship_to_different_address"]').length > 0) {
      formDataObj['ship_to_different_address'] = jQuery('input[name="ship_to_different_address"]').first().is(':checked');
    }

    if (jQuery('input[name="legal"]').length > 0) {
      formDataObj['legal'] = jQuery('input[name="legal"]').first().is(':checked');
    }

    if (jQuery('input[name="payment_method"]:checked').length > 0) {
      formDataObj['payment_method'] = jQuery('input[name="payment_method"]:checked').val();
    }

    // console.log(formDataObj);
    return formDataObj;
  }
}


class CheckoutOverviewRow {
  constructor(element, checkoutSteps) {
    this.container = jQuery(element);
    this.element = jQuery(element).find('> .mad-checkout-overview__row');
    this.stepId = this.element.data('step-id');
    this.isVisible = false;
    this.name = this.element.find('.mad-checkout-overview__row--name').text();
    this.content = this.element.find('.mad-checkout-overview__row-content').html();
    this.button = this.element.find('.mad-checkout-overview__row--button a');
    this.checkoutSteps = checkoutSteps;

    this.attachButtonClickHandler();
  }

  attachButtonClickHandler() {
    this.button.on('click', (e) => {
      e.preventDefault();
      this.checkoutSteps.changeStepById(this.stepId);
    });
  }

  toggleVisibility(currentStepId, checkoutSteps) {
    if (checkoutSteps.isBeyondStep(currentStepId, this.stepId)) {
      this.element.show();
      this.isVisible = true;
    } else {
      this.element.hide();
      this.isVisible = false;
    }
  }
}

module.exports = CheckoutOverview;